module.exports = __webpack_public_path__ + "img/thumb.a2f7f33b.png";